import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Switch from "../components/Switch";
import Info from "../components/Info";
import Footer from "../components/Footer";
import Faq from "../components/Faq";
import WhyPremisin from "../components/WhyPremisin";
import AboutUs from "../components/AboutUs";
import Workspace from "../components/Workspace";
import OurLocation from "../components/OurLocation";
import OurClient from "../components/OurClient";
import OurOffice from "../components/OurOffice";
import ClientReview from "../components/ClientReview";
import Loader from "../components/Loader";

const Landing = () => {
  const [loading, setLoading] = useState(true);
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // });
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 300);
  });
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div id="top" className="dino-startup">
          <Navbar />
          <Hero />
          <Switch />
          <Info />
          <OurOffice />
          <WhyPremisin />
          <OurClient />
          <ClientReview />
          <AboutUs />
          <Workspace />
          <OurLocation />
          <Faq />
          <Footer />
        </div>
      )}
    </>
  );
};

export default Landing;
